// Web replacement for react-native-image-picker.
// The app calls this two ways: `await launchX(options)` and
// `launchX(options, callback)` (sometimes chaining `.then()` on the
// result of the callback form too) — this always returns a Promise
// *and* invokes the callback when one is passed, so both call sites work.
function pickFile(capture) {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    if (capture) input.capture = capture;
    input.style.display = 'none';
    document.body.appendChild(input);

    input.addEventListener('change', () => {
      const file = input.files && input.files[0];
      input.remove();

      if (!file) {
        resolve({ didCancel: true });
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        const uri = typeof reader.result === 'string' ? reader.result : '';
        resolve({
          didCancel: false,
          assets: [
            {
              uri,
              fileName: file.name,
              type: file.type,
              fileSize: file.size,
              base64: uri.includes(',') ? uri.split(',')[1] : undefined,
            },
          ],
        });
      };
      reader.onerror = () => {
        resolve({ didCancel: false, errorCode: 'other', errorMessage: 'Failed to read the selected file.' });
      };
      reader.readAsDataURL(file);
    });

    document.body.appendChild(input);
    input.click();
  });
}

function run(capture, callback) {
  const promise = pickFile(capture).then((result) => {
    if (callback) callback(result);
    return result;
  });
  return promise;
}

export function launchCamera(options = {}, callback) {
  const capture = options.cameraType === 'front' ? 'user' : 'environment';
  return run(capture, callback);
}

export function launchImageLibrary(options = {}, callback) {
  return run(undefined, callback);
}
